
  import ModalDefault from '@/components/main/ui/ModalDefault.vue'
  import InputPassword from '@/components/main/ui/InputPassword.vue'
  import ButtonDefault from '@/components/main/ui/ButtonDefault.vue'
  import { usePasswordChangeGate } from '@/composables/auth/usePasswordChangeGate'

  /**
   * Не закрываемая модалка: пользователь вошёл с временным паролем и обязан задать новый.
   */
  export default {
    name: 'ForcePasswordChangeModal',
    components: {
      ModalDefault,
      InputPassword,
      ButtonDefault,
    },
    setup() {
      return usePasswordChangeGate()
    },
  }
